import { Button, Grid, Typography, useTheme } from '@mui/material';
import { SnackbarActionTypes, useSnackbarDispatch } from 'contexts/snackbar/SnackbarContext';
import Mui from 'materials';
import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { usePondsState } from 'views/production-systems/context/ponds-context';
import { useTimer } from 'views/production-systems/hooks/use-timer';

type TimerProps = {
  handleDialogClose?: () => void;
};

const PondLockTimer: React.FC<TimerProps> = ({ handleDialogClose }) => {
  const { time, reset, extend, isFinished } = useTimer({ initialMinutes: 20 });
  const { extendPonds, lockedPonds } = usePondsState();
  const theme = useTheme();
  const intl = useIntl();
  const snackbarDispatch = useSnackbarDispatch();

  const validateTime = () => time.minutes < 1 && time.seconds <= 30;

  const closeDialog = () => {
    handleDialogClose?.();
    snackbarDispatch({
      type: SnackbarActionTypes.WARNING_SNACKBAR,
      payload: {
        msg: intl.formatMessage({ id: 'productionSystems.timer.error' }),
      },
    });
    reset();
  };

  useEffect(() => {
    if (isFinished) {
      closeDialog();
    }
  }, [isFinished]);

  const handleClick = () => {
    extendPonds(lockedPonds.granted);

    extend();
  };

  const formatSeconds = (time: { minutes: number; seconds: number }) => {
    const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`);
    return `${pad(time.minutes)}:${pad(time.seconds)}`;
  };

  return (
    <Grid
      container
      rowSpacing={4}
      width={{ md: '50%', xs: '100%' }}
      alignItems="center"
      justifyContent={'space-between'}
      p={4}
      mb={6}
      borderRadius={2}
      sx={{
        backgroundColor: validateTime() ? theme.palette.red.o50 : theme.palette.orange.o50,
      }}>
      <Grid size={{ xs: 6, md: 9 }}>
        <Typography variant="inherit" component="p" fontSize={14}>
          {intl.formatMessage(
            { id: 'productionSystems.timer.expire' },
            {
              time: <strong>{formatSeconds(time)}</strong>,
            }
          )}
        </Typography>
      </Grid>
      <Grid size={{ xs: 6, md: 3 }}>
        <Button
          variant="outlined"
          sx={{
            backgroundColor: validateTime() ? theme.palette.red.o50 : theme.palette.orange.o50,
            color: theme.palette.darkBlue.main,
            borderColor: `${theme.palette.darkBlue.main} !important`,
            fontSize: 12,
          }}
          onClick={handleClick}>
          <FormattedMessage id={'productionSystems.timer.reset'} />
        </Button>
      </Grid>
    </Grid>
  );
};

export default PondLockTimer;
